import day from "dayjs";
import { Button, Divider, Popover } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import { useState } from "react";

const TWO_WEEKS = "TWO_WEEKS";
const ONE_MONTH = "ONE_MONTH";
const TWO_MONTHS = "TWO_MONTHS";
const SIX_MONTHS = "SIX_MONTHS";
const CALENDAR_YEAR = "CALENDAR_YEAR";

const NEXT_TWO_WEEKS = "NEXT_TWO_WEEKS";
const NEXT_ONE_MONTH = "NEXT_ONE_MONTH";
const NEXT_TWO_MONTHS = "NEXT_TWO_MONTHS";
const NEXT_SIX_MONTHS = "NEXT_SIX_MONTHS";

const ON_SELECT = {
  [TWO_WEEKS]: () => [day().subtract(2, "weeks"), day()],
  [ONE_MONTH]: () => [day().subtract(1, "month"), day()],
  [TWO_MONTHS]: () => [day().subtract(2, "month"), day()],
  [SIX_MONTHS]: () => [day().subtract(6, "month"), day()],
  [CALENDAR_YEAR]: () => [
    day().dayOfYear(1).hour(0).minute(0).second(0).millisecond(0),
    day(),
  ],

  [NEXT_TWO_WEEKS]: () => [day(), day().add(2, "weeks")],
  [NEXT_ONE_MONTH]: () => [day(), day().add(1, "month")],
  [NEXT_TWO_MONTHS]: () => [day(), day().add(2, "month")],
  [NEXT_SIX_MONTHS]: () => [day(), day().add(6, "month")],
};

const selectRangeValue = (setRange, setVisible) => (rangeValue) => () => {
  setVisible(false);
  setRange(ON_SELECT[rangeValue]);
};

export const RangeFilter = (props) => {
  const { allowFuture, setRange } = props;

  const [visible, setVisible] = useState(false);
  const onSelect = selectRangeValue(setRange, setVisible);

  const content = (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <Button
        size={"small"}
        style={{ marginRight: "8px", marginBottom: "4px" }}
        onClick={onSelect(TWO_WEEKS)}
      >
        Last Two Weeks
      </Button>
      <Button
        size={"small"}
        style={{ marginRight: "8px", marginBottom: "4px" }}
        onClick={onSelect(ONE_MONTH)}
      >
        Last Month
      </Button>
      <Button
        size={"small"}
        style={{ marginRight: "8px", marginBottom: "4px" }}
        onClick={onSelect(TWO_MONTHS)}
      >
        Last Two Months
      </Button>
      <Button
        size={"small"}
        style={{ marginRight: "8px", marginBottom: "4px" }}
        onClick={onSelect(SIX_MONTHS)}
      >
        Last Six Months
      </Button>
      <Button
        size={"small"}
        style={{ marginRight: "8px" }}
        onClick={onSelect(CALENDAR_YEAR)}
      >
        Calendar Year
      </Button>

      {allowFuture && (
        <>
          <Divider style={{ margin: "8px 0px" }} />
          <Button
            size={"small"}
            style={{ marginRight: "8px", marginBottom: "4px" }}
            onClick={onSelect(NEXT_TWO_WEEKS)}
          >
            Next Two Weeks
          </Button>
          <Button
            size={"small"}
            style={{ marginRight: "8px", marginBottom: "4px" }}
            onClick={onSelect(NEXT_ONE_MONTH)}
          >
            Next Month
          </Button>
          <Button
            size={"small"}
            style={{ marginRight: "8px", marginBottom: "4px" }}
            onClick={onSelect(NEXT_TWO_MONTHS)}
          >
            Next Two Months
          </Button>
          <Button
            size={"small"}
            style={{ marginRight: "8px" }}
            onClick={onSelect(NEXT_SIX_MONTHS)}
          >
            Next Six Months
          </Button>
        </>
      )}
    </div>
  );

  return (
    <Popover
      content={content}
      onOpenChange={setVisible}
      placement={"bottom"}
      trigger={"click"}
      open={visible}
    >
      <Button ghost icon={<MoreOutlined />} size="small" type="primary" />
    </Popover>
  );
};
